import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import DEFAULT_OPERATIONS from './createWishlistForm.gql';
import { useFormState } from 'informed';
export var useCreateWishlistForm = function useCreateWishlistForm(props) {
  var onCancel = props.onCancel,
      onCreateList = props.onCreateList,
      isAddLoading = props.isAddLoading;
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);

  var _useMutation = useMutation(operations.createWishlistMutation),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      createList = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      isCreateLoading = _useMutation2$.loading,
      createWishlistError = _useMutation2$.error;

  var _useFormState = useFormState(),
      values = _useFormState.values;

  var handleCancel = useCallback(function () {
    onCancel();
  }, [onCancel]);
  var handleSave = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var visibility, _yield$createList, data, wishlistId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            visibility = values.visibility ? values.visibility : 'PRIVATE';
            _context.next = 4;
            return createList({
              variables: {
                name: values.listname,
                visibility: visibility
              }
            });

          case 4:
            _yield$createList = _context.sent;
            data = _yield$createList.data;
            wishlistId = data.createWishlist.wishlist.id;
            onCreateList(wishlistId);
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  })), [createList, onCreateList, values]);
  return {
    formErrors: [createWishlistError],
    handleCancel: handleCancel,
    handleSave: handleSave,
    isSaveDisabled: isCreateLoading || isAddLoading
  };
};